import "./Loader.css";
import Spinner from "react-bootstrap/Spinner";
import { useAppContext } from "../../context/app-context";

interface Props {
  isLoading?: boolean;
  isFullScreen?: boolean;
}

const Loader = ({ isFullScreen = false, isLoading = false }: Props) => {
  const { loading, loadingText } = useAppContext();

  return (
    <div
      className={`loader-cont ${loading || isLoading ? "d-flex" : "d-none"} ${
        isFullScreen ? "loader-container-full" : "loader-container-center"
      }`}
    >
      <div className="loader-box">
        <Spinner animation="border" className="loader" variant="success" />
        <div className="loader-text">{loadingText}</div>
      </div>
    </div>
  );
};

export default Loader;
